var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "close",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_38",
    "data-name": "Rect\\xE1ngulo 38",
    width: 24,
    height: 24,
    fill: "#fff",
    opacity: 0
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Uni\\xF3n_1",
    "data-name": "Uni\\xF3n 1",
    d: "M11354.016,1718.077l-7.893-7.893-7.893,7.893a.77.77,0,1,1-1.061-1.06l7.892-7.893-7.892-7.892a.771.771,0,1,1,1.061-1.063l7.893,7.893,7.893-7.893a.771.771,0,1,1,1.06,1.063l-7.891,7.891,7.894,7.894a.866.866,0,0,1,.137,1.2.654.654,0,0,1-.473.185A1.052,1.052,0,0,1,11354.016,1718.077Z",
    transform: "translate(-11333.936 -1696.934)",
    fill: "#1c1c1c",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.6ad65c36406024fbf953aa7766095b0e.svg";
export { ForwardRef as ReactComponent };